
import { Component, Prop, Vue } from 'vue-property-decorator'
import PaymentInfo from '@/commons/components/summary/content/PaymentInfo.vue'
import ContactInfo from '@/commons/components/summary/content/ContactInfo.vue'
import ApplicantInfo from '@/commons/components/summary/content/ApplicantInfo.vue'
import ParentsContent from '@/commons/components/summary/content/ParentsContent.vue'
import PlaceOfIssueSummary from '@/commons/components/summary/content/PlaceOfIssueSummary.vue'
import MainDetailsAndBiometry from '@/commons/components/summary/content/MainDetailsAndBiometry.vue'
import ApplicationReasonsSummary from '@/commons/components/summary/content/ApplicationReasonsSummary.vue'
import { applicantStore } from '@/store'
import { RouterUtils } from '@/commons/utils/router'

@Component({
    components: {
        ContactInfo,
        PaymentInfo,
        ApplicantInfo,
        ParentsContent,
        PlaceOfIssueSummary,
        MainDetailsAndBiometry,
        ApplicationReasonsSummary
    }
})
export default class SummaryInfo extends Vue {
    @Prop() heading!: string
    @Prop() toggleLoadingSpinner!: () => void

    async goBack (): Promise<void> {
        await this.$router.push(this.$route.path.replace('summary', 'create'), RouterUtils.setFocusToBody)
    }

    get isValidApplicant (): boolean {
        return applicantStore.isValidApplicant
    }
}
